import React, { useState } from 'react';
import SplashScreenBackground from '../v2BaseComponents/SplashScreenBackground';
import { Platform } from 'react-native';

export type ResetAppProviderProps = {
    children: React.ReactElement;
};

export type ResetApp = (delay?: number) => void;

export const ResetAppContext = React.createContext<ResetApp>(() => {
    return;
});

export const useResetApp = () => React.useContext(ResetAppContext);

export const ResetAppProvider: React.FC<ResetAppProviderProps> = React.memo(({ children }) => {
    const [isPendingReset, setIsPendingReset] = useState(false);
    const [resetKey, setResetKey] = React.useState(0);
    const resetApp = React.useCallback((delay?: number) => {
        setIsPendingReset(true);
        // nosemgrep
        setTimeout(() => {
            /**
             * Web apps will initialize the screen from the url.  this can cause
             * unintended behavior (such as infinite loops from the redirect page)
             *
             * Resetting the url will effectively reset the navigation state on the web
             */
            if (Platform.OS === 'web') {
                window.location.href = '/';
            }

            setResetKey((prev) => prev + 1);
            setIsPendingReset(false);
        }, delay);
    }, []);

    const content = (
        <ResetAppContext.Provider value={resetApp}>
            {React.cloneElement(children, { key: resetKey })}
        </ResetAppContext.Provider>
    );

    return isPendingReset ? <SplashScreenBackground /> : content;
});
